import { colorConstants } from 'config/colorConstants';
import { renderTitle } from './getSalesAttributionColumns';
import { formatNumWithKMBAlt } from './helperMethods';
import DownSvg from 'assets/svg/Down';
import UpAltSvg from 'assets/svg/UpAlt';
import { graphXAxisLabelFontSize } from 'components/organism/GrowthAnalysis/BrandValueChartContainer/BrandValueChartContainer';
import _ from 'lodash';
import { trackEventMixpanel } from './mixpanel';
import { PRICE_POINT_TABLE_ROW_EXPANDED } from './mixpanelEventNames';

export const getPricePointColumns = (
    data: any,
    expandedIndex: null | number,
    setExpandedIndex: Function,
    decimalForNonPercentage: number,
    decimalForPercentage: number,
): any => {
    let result = [];
    const keys = data && data.length > 0 ? Object.keys(data?.[0]) : [];
    const sliceKeys = Array.isArray(keys) ? keys.slice(0, keys?.length - 2) : [];
    const columns =
        data && data.length > 0
            ? sliceKeys.map((item: any, index: number) => {
                  return {
                      title:
                          index === 0 || index === sliceKeys.length - 1
                              ? ''
                              : renderTitle(
                                    item,
                                    undefined,
                                    undefined,
                                    'text-purpleFont !font-bold',
                                    graphXAxisLabelFontSize,
                                ),
                      //title: index > 1 ? renderTitle(item) : '',
                      dataIndex: item,
                      key: item,
                      align: index === 0 ? 'left' : 'center',
                      fixed: index === 0 ? 'left' : index === sliceKeys?.length - 1 ? 'right' : null,
                      width: index === 0 ? 150 : index === sliceKeys?.length - 1 ? 40 : 100,
                      onCell: (rowData: any, rowIndex: any) => {
                          const hideNestedData =
                              rowData['nestedIndex'] !== null && rowData['nestedIndex'] !== expandedIndex;

                          return {
                              style: {
                                  textAlign: index === 0 ? 'auto' : 'center',
                                  backgroundColor:
                                      expandedIndex !== null &&
                                      (rowData['nestedIndex'] === expandedIndex || rowIndex === expandedIndex)
                                          ? colorConstants.lightPurple
                                          : 'white',
                              },
                              colSpan: hideNestedData ? 0 : 1,
                          };
                      },

                      //else render data
                      render(columnData: any, rowData: any, rowIndex: any) {
                          const hideNestedData =
                              rowData['nestedIndex'] !== null && rowData['nestedIndex'] !== expandedIndex;
                          //if index ===0 render label
                          if (!hideNestedData && index === 0)
                              return (
                                  <div className="font-xs flex items-center gap-1">
                                      {rowData?.color && (
                                          <span
                                              className="h-2 w-2 flex-shrink-0"
                                              style={{ background: rowData?.color }}
                                          ></span>
                                      )}
                                      <p>{<div className="font-xs font-medium">{columnData}</div>}</p>
                                  </div>
                              );

                          // if index is last render dropdown
                          if (!hideNestedData && index === sliceKeys.length - 1 && rowData['isExpandable']) {
                              return (
                                  <span
                                      onClick={() => {
                                          //resetting
                                          if (expandedIndex === rowIndex) setExpandedIndex(null);
                                          else {
                                              setExpandedIndex(rowIndex);

                                              //mixpanel event
                                              trackEventMixpanel(PRICE_POINT_TABLE_ROW_EXPANDED, {
                                                  rowName: rowData?.label,
                                              });
                                          }
                                      }}
                                      className="cursor-pointer flex justify-center items-center w-fit"
                                  >
                                      {expandedIndex === rowIndex ? <UpAltSvg /> : <DownSvg />}
                                  </span>
                              );
                          }
                          //else render data
                          if (!hideNestedData) {
                              if (_.isNull(columnData?.value) || _.isUndefined(columnData?.value)) return '';
                              return (
                                  <div>
                                      <span className="font-xs">
                                          {columnData?.pre}
                                          {formatNumWithKMBAlt(
                                              columnData?.value,
                                              columnData?.post !== '%' ? decimalForNonPercentage : decimalForPercentage,
                                              columnData?.post !== '%' ? decimalForNonPercentage : undefined,
                                          )}
                                          {columnData?.post}
                                      </span>
                                  </div>
                              );
                          }

                          return '';
                      },
                  };
              })
            : [];

    result = [...columns];
    return result;
};

export const getPricePointDrilldownColumns = (
    data: any[],
    yAxisDropdownData: any,
    decimalForNonPercentage: number,
    decimalForPercentage: number,
) => {
    let result: any[] = [];
    let columns = data && Array.isArray(data) && data.length > 0 ? Object.keys(data?.[0]) : [];

    // always put label in the 0th index to avoid column distortion when keys are of numerical
    columns = ['label', ...columns.filter((col: string) => col !== 'label')];

    result = columns.map((key, idx) => {
        return {
            title: renderTitle(
                idx === 0 ? '' : key,
                idx === 0 ? null : 'center',
                undefined,
                'text-purpleFont !font-bold',
                graphXAxisLabelFontSize,
            ),
            dataIndex: key,
            width: 100,
            key: key,
            fixed: idx === 0 ? 'left' : false,
            align: idx === 0 ? 'left' : 'center',

            render: (columnData: any, rowData: any, rowIndex: number) => {
                if (typeof columnData === 'string') {
                    return <div className="font-xs text-greyFont font-medium">{columnData}</div>;
                }
                return (
                    <>
                        {!_.isNull(columnData?.val) && (
                            <div className="text-greyFont font-xs">
                                {yAxisDropdownData?.value === 'value' ? columnData?.pre : ''}
                                {formatNumWithKMBAlt(
                                    columnData?.val,
                                    columnData?.post !== '%' ? decimalForNonPercentage : decimalForPercentage,
                                    columnData?.post !== '%' ? decimalForNonPercentage : undefined,
                                )}
                                {columnData?.post}
                            </div>
                        )}
                    </>
                );
            },
        };
    });

    return result;
};
